<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="text-left"
        >
          <b-form-group
            label="Ara"
            label-for="search"
          >
            <b-form-input
              id="search"
              v-model="search"
              placeholder="Ara"
              @keyup.enter="searchVal(search)"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="text-right mt-1"
        >
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(title)="data">
        {{ data.item.title }}
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            :edit-action="$route.path + '/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="data.item.id"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard,
  BCardBody,
  BTable,
  BFormInput,
  BPagination,
  BButton,
  BCol,
  BRow,
  BCardFooter,
  BFormGroup,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'projects'
export default { // default ilgili verileri göstermek içi kullanılıyor
  name: 'Index', // vue bileşenin adı
  components: {
    BFormGroup, // vue'nin kullanacağı bileşenler listesi
    BCard,
    BCardBody,
    BTable,
    BCol,
    BRow,
    BPagination,
    BButton,
    BFormInput,
    BCardFooter,
    ListButtons,
  },
  data() {
    return {
      currentPage: 1,
      search: '',
      perPage: this.$store.state.app.perPage, // her sayfa için göstrilecek sayfa sayısı
      fields: [// tabloda gösterilecek sütunlar tanımlanır
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: { // veri alınacak sorgu
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: { // getter'lardan gelen veriler döndürülür
    dataList() {
      return this.$store.getters['projects/dataList']
    },
    dataCounts() {
      return this.$store.getters['projects/dataCounts']
    },
    saveData() {
      return this.$store.getters['projects/dataSaveStatus']
    },
  },
  watch: { // aktif sayfayı izler ve değişiklik olduğunda start güncellenir ve tekrardan veriler çağırılır
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) { // save data değiştiğinde çağrılır ve ekrana mesaj döndürür
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() { // vue oluşturulduğunda çağrılır veri listesi gelir
    this.getDataList()
  },
  methods: {
    searchVal(val) {
      const sanitizedVal = val ? val.replace(/'/g, "''") : ''
      this.dataQuery.where = sanitizedVal ? `title LIKE '%${sanitizedVal}%'` : ''
      this.getDataList()
    },
    getDataList() { // stora ilgili dataQuery gönderilir ve çağrılır
      this.$store.dispatch('projects/getDataList', this.dataQuery)
    },
    removeData(id) { // idyi alarak veri silme işlemini gerçekleştirir ve ekrana mesaj döndürür. swal kullanarak onay alınır ve store'dan veri kaldırılır
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('projects/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) { // toast mesajı gösterir
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
